import { proforientationRecommendationSelectors } from 'portfolio3/features/proforientation/model/selectors';
import { createSelector } from 'reselect';
import { extractDatesFromNestedItems } from 'utils';

export const proforientationRecommendationDodsYearsSelector = createSelector(
  [proforientationRecommendationSelectors.dods],
  (proforientationRecommendationDods) =>
    extractDatesFromNestedItems(
      [proforientationRecommendationDods],
      [
        {
          type: 'date',
          field: 'unformattedEventDate',
        },
      ],
    ),
);
